import { render } from "./PredictionDashboard.vue?vue&type=template&id=0cc2c582&scoped=true"
import script from "./PredictionDashboard.vue?vue&type=script&lang=js"
export * from "./PredictionDashboard.vue?vue&type=script&lang=js"

import "./PredictionDashboard.vue?vue&type=style&index=0&id=0cc2c582&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc2c582"]])

export default __exports__